<template>
  <a-card>
    <a-tabs
      @change="handleChange"
      :animated="false"
      :activeKey="String(activeKey)"
    >
      <a-tab-pane v-for="(item, index) in tabs" :key="String(index)">
        <a-badge
          slot="tab"
          :count="(upcomingList && upcomingList[item.countName]) || 0"
          :overflowCount="9999"
          :offset="badgeOffset"
        >
          <span>{{ item.label }}</span>
        </a-badge>
      </a-tab-pane>
    </a-tabs>
    <div class="table-wrapper">
      <TableView
        size="small"
        :data="tableData"
        :columns="columns"
        :pagination="false"
        :scroll="scroll"
        :loading="tableLoading"
        rowKey="key"
      >
        <template v-slot:companyName="{ tableRow }">
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ tableRow.companyName }}</span>
            </template>
            <span>{{ tableRow.companyName }}</span>
          </a-tooltip>
        </template>
        <template v-slot:applyDate="{ tableRow }">
          {{
            isTodoStatus
              ? tableRow.applyDate
              : tableRow.applyDate && tableRow.applyDate.split(' ')[0]
          }}
        </template>
        <template v-slot:action="{ tableRow }">
          <a-button type="link" @click="toApprovePage(tableRow)">
            审核
          </a-button>
        </template>
      </TableView>
    </div>
    <!-- :class="['text-center', tableData.length === 5 ? '' : 'hidden']" -->
    <div
      :class="['text-center', tableData.length ==='']"
      style="padding: 5px 0;"
    >
      <a-button type="link" @click="handleMore">
        查看更多
        <a-icon type="arrow-right" />
      </a-button>
      <a-button type="link" @click="handleMoreBatch" v-if="this.activeKey != 4">
          查看更多（批量）
        <a-icon type="arrow-right" />
      </a-button>
    </div>
  </a-card>
</template>

<script>
import { TableView } from 'lxfintech-fe'
import {
  getUpcomings,
  getApproveAllList,
  getBatchApproveList,
  getGroupApproveAllList,
  // getApprovedList,
  getGroupBrachApproveList,
  getGuaranteeApproved,
  // getRejectedList,
  getLimitAllList,
  getPeriodAllList,
} from '../api'
import { ERR_OK } from '@/config'

export default {
  name: 'ApproveTabs',
  data() {
    return {
      upcomingList: null,
      tabs: [
        {
          label: '信用待审批',
          action: '_getApproveList',
          countName: 'taskCount',
        },
        // {
        //   label: '批量待审批',
        //   action: '_getBatchApproveList',
        //   countName: 'taskBatchCount',
        // },
        {
          label: '延期待审批',
          action: '_getLimitList',
          countName: 'limitCount',
        },
        {
          label: '集团关系待审批',
          action: '_getGroupApproveList',
          countName: 'relationCount',
        },
        // {
        //   label: '集团关系批量待审批',
        //   action: '_getGroupBrachApproveList',
        //   countName: 'relationBatchCount',
        // },
        {
          label: '账期调整待审批',
          action: '_getPeriodAllList',
          countName: 'periodCount',
        },
        {
          label: '担保待审批',
          action: '_getGuaranteeApproved',
          countName: 'assuranceCount',
        },
        // {
        //   label: '审批通过',
        //   action: '_getApprovedList',
        //   countName: 'successCount',
        // },
        // {
        //   label: '审批未通过',
        //   action: '_getRejectedList',
        //   countName: 'failCount',
        // },
      ],
      badgeOffset: [18, 0],
      numberStyle: {
        width: '20px',
        height: '20px',
        fontSize: '10px',
      },
      activeKey: '0',
      tableData: [],
      pageData: {
        size: 5,
        current: 1,
      },

      tableLoading: false,
      approvalOrApply: '', //判断是审批页还是申请页
    }
  },
  computed: {
    isTodoStatus() {
      return (
        this.activeKey == 0 ||
        this.activeKey == 1 ||
        this.activeKey == 2 ||
        this.activeKey == 3
      )
    },

    scroll() {
      return { x: this.activeKey != 1 ? 1000 : 800 }
    },
    columns() {
      return [
        this.activeKey !== 2 &&{
            title: '流水号',
            width: 240,
            dataIndex: 'id',
          },
        this.activeKey == 2 && {
          title: '申请单号',
          width: 240,
          dataIndex: 'bpmId',
        },
        // this.activeKey == 3 && {
        //   title: '申请单号',
        //   width: 240,
        //   dataIndex: 'bpmId',
        // },
        this.activeKey == 2 && {
          title: '母公司名称',
          width: 240,
          dataIndex: 'parentName',
        },
        this.activeKey !== 2 &&{
            title: '企业名称',
            dataIndex: 'companyName',
            width: 240,
            ellipsis: true,
            slotName: 'companyName',
            scopedSlots: { customRender: 'companyName' },
          },
        {
          title: '申请人',
          width: 150,
          ellipsis: true,
          dataIndex: 'applyPerson',
        },
        // this.activeKey == 0 || this.activeKey == 2 || this.activeKey == 4
        //       ? 'applyPerson'
        //       : applier
        {
          title: '申请时间',
          width: 120,
          scopedSlots: { customRender: 'applyDate' },
        },
        this.activeKey !== 3 &&
        this.activeKey !== 4 && {
            title: '审批角色',
            width: 120,
            ellipsis: true,
            dataIndex: 'applyRole',
          },
        this.activeKey == 4 && {
          title: '审批状态',
          width: 120,
          ellipsis: true,
          dataIndex: 'statusStr',
        },
        {
          title: '操作',
          fixed: 'right',
          width: 80,
          dataIndex: 'action',
          slotName: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
  },
  mounted() {
    this._getApproveList()
    this._getUpcoming()
  },
  methods: {
    _getUpcoming() {
      return getUpcomings().then(({ data }) => {
        this.upcomingList = data
      })
    },
    handleChange(index) {
      index = Number(index)
      this.activeKey = index
      let actionName = this.tabs[index] && this.tabs[index].action
      actionName && this[actionName] && this[actionName]()
    },
    toApprovePage(row) {
      const { id, type, status, companyCode, sn, parentName } = row
      if (this.activeKey == 0) {
        if(companyCode == undefined || companyCode == ""){
          this.$router.push({
          path: `/credit-approval/audit/batch-approval-detail/${id}`,
          //customer-credit/approved-approval
          query: {
            companyCode: row.childCode,
            status: 1,//批量信用
          },
          })
        }else{
          this.$router.push({
          path: `/credit-approval/audit/approval-detail/${id}`,
          query: {
            type,
            status,
            companyCode,
            sn,
            approvalOrApply: 1, //1是审批页 信用
          },
          })
        }
      } else if (this.activeKey == 1) {
        if(companyCode == undefined || companyCode == ""){
          this.$router.push({
            path: `/credit-approval/limit/limit-batch-approval-detail/${row.id}`,
          })
        }else{
          this.$router.push({
            path: `/credit-approval/limit/approval-detail/${id}`,
            query: {
              type,
              status,
              companyCode,
              sn,
              approvalOrApply: 1,
            },
          })
        }
      }else if (this.activeKey == 2) {
        if(parentName == undefined || parentName == ""){
          this.$router.push({
            path: `/customer-credit/group-relationship-batch-detail/${row.bpmId}`,
            query: {
              status: 1,
            },
          })
        }else{
          this.$router.push({
            path: `/customer-credit/approved-approval/${row.bpmId}`,
            query: {
              companyCode: row.childCode,
              status: 1,
            },
          })
        }
      } else if (this.activeKey == 3) {
        if(companyCode == undefined || companyCode == ""){
          this.$router.push({
            path: `/Item/period-batch/period-batch-approval-detail/${row.id}`,
          })
        }else{
          this.$router.push({
            path: `/credit-approval/approve/approve-detail/${id}`,
            query: {
              type: 1,
              status,
              companyCode,
              sn,
              approvalOrApply: 1,
            },
          })
        }
      } else {
        this.$router.push({
          path: `/Item/guarantee-detail/guarantee-approval/${row.bpmId}?companyCode=${row.companyCode}`,
        })
      }
    },
    toDetailPage(row) {
      const { id, type, status } = row
      this.$router.push({
        path: `/credit-approval/apply-detail/${id}`,
        query: {
          type,
          status,
        },
      })
    },
    async _getApproveList() {
      this.tableLoading = true
      const { code, data } = await getApproveAllList(this.pageData)
      if (code === ERR_OK) {
        this.tableData = data.records.map(item => {
          item.key = item.id
          return item
        })
        this.tableLoading = false
      }
    },
    async _getPeriodAllList() {
      this.tableLoading = true
      const { code, data } = await getPeriodAllList(this.pageData)
      if (code === ERR_OK) {
        this.tableData = data.records.map(item => {
          item.key = item.id
          return item
        })
        this.tableLoading = false
      }
    },
    async _getLimitList() {
      this.tableLoading = true
      const { code, data } = await getLimitAllList(this.pageData)
      if (code === ERR_OK) {
        this.tableData = data.records.map(item => {
          item.key = item.id
          return item
        })
        this.tableLoading = false
      }
    },
    async _getGuaranteeApproved() {
      this.tableLoading = true
      const { code, data } = await getGuaranteeApproved(this.pageData)
      if (code === ERR_OK) {
        this.tableData = data.records
        this.tableLoading = false
      }
    },
    async _getGroupBrachApproveList() {
      this.tableLoading = true
      const { code, data } = await getGroupBrachApproveList(this.pageData)
      if (code === ERR_OK) {
        this.tableData = data.records.map(item => {
          item.key = item.id
          return item
        })
        this.tableLoading = false
      }
    },
    async _getGroupApproveList() {
      this.tableLoading = true
      const { code, data } = await getGroupApproveAllList(this.pageData)
      if (code === ERR_OK) {
        this.tableData = data.records.map(item => {
          item.key = item.id
          return item
        })
        this.tableLoading = false
      }
    },
    async _getBatchApproveList() {
      this.tableLoading = true
      const { code, data } = await getBatchApproveList(this.pageData)
      if (code === ERR_OK) {
        this.tableData = data.records.map(item => {
          item.key = item.id
          return item
        })
        this.tableLoading = false
      }
    },
    // async _getApprovedList() {
    //   this.tableLoading = true
    //   let params = {
    //     ...this.pageData,
    //     status: 1,
    //   }
    //   const { code, data } = await getApprovedList(params)
    //   if (code === ERR_OK) {
    //     this.tableData = data.records.map(item => {
    //       item.key = `${item.id}_${item.approveDate}`
    //       return item
    //     })
    //     this.tableLoading = false
    //   }
    // },
    // async _getRejectedList() {
    //   this.tableLoading = true
    //   let params = {
    //     ...this.pageData,
    //     status: 2,
    //   }
    //   const { code, data } = await getRejectedList(params)
    //   if (code === ERR_OK) {
    //     this.tableData = data.records.map(item => {
    //       item.key = `${item.id}_${item.approveDate}`
    //       return item
    //     })
    //     this.tableLoading = false
    //   }
    // },
    handleMore() {
      let activeKey = Number(this.activeKey)
      switch (activeKey) {
        case 0:
          this.$router.push('/credit-approval/audit/audit-list')
          break
        case 1:
          this.$router.push('/credit-approval/limit/limit-list')
          break
        case 2:
          this.$router.push('/customer-credit/group-relationship-approved')
          break
        case 3:
          this.$router.push('/credit-approval/approve/approve-list')
          break
        case 4:
          this.$router.push('/Item/guarantee-detail/approve')
          break
      }
    },
    handleMoreBatch() {
      let activeKey = Number(this.activeKey)
      switch (activeKey) {
        case 0:
          this.$router.push('/credit-approval/audit/batch-audit-list')
          break
        case 1:
          this.$router.push('/credit-approval/limit/batch-limit-list')
          break
        case 2:
          this.$router.push('/customer-credit/group-relationship-batch-approval')
          break
        case 3:
          this.$router.push('/Item/period-batch/batch-period-list')
          break
      }
    },
  },
  components: {
    TableView,
  },
}
</script>
<style lang="less" scoped>
.hidden {
  visibility: hidden;
}
.table-wrapper {
  // height: 325px;
  // display: flex;
  // flex-direction: column;
  // justify-content: space-between;
  height: 282px;
  overflow-y: auto;
  padding: 0 16px;
  /deep/ .ant-table-small {
    border-bottom: none;
  }
}
</style>
